import { DefaultMantineColor, MantineColorsTuple } from '@mantine/core'

// https://www.figma.com/file/vneiNLHRoblG0cYL6fgUNw/system-4.0?node-id=107%3A794&t=Bu0H8p3GmISlEUpT-0
export const defaultColors: Partial<Record<DefaultMantineColor, MantineColorsTuple>> = {
  unique: [
    '#F8D882',
    '#E5DFD2',
    '#F7F0E2',
    '#FAE2AA',
    '#E5DFD2',
    '#51B16E',
    '#F1F9FE', // Declared up to here. Update as needed.
    '#E59E10',
    '#51926D',
    '#2D99AB',
    '#6E1A5F',
  ] as MantineColorsTuple,
  'brand-blue': [
    '#F2F4FD',
    '#E7EFFD',
    '#C7D1F9',
    '#A4B6F6',
    '#7796F3',
    '#286EF0',
    '#2362D6', // 6. Brand Blue
    '#1E55B9',
    '#194597',
    '#11316B', // 9. Brand Dark Blue
  ] as MantineColorsTuple,
  'light-gray': [
    '#FDFDFD',
    '#FCFCFC',
    '#F9F9F9',
    '#F6F6F6',
    '#F3F3F3',
    '#F0F0F0',
    '#D6D6D6', // 6. Light Gray card border and disabled button
    '#B9B9B9',
    '#979797',
    '#6B6B6B',
  ] as MantineColorsTuple,
  gray: [
    '#FAFBFB',
    '#F6F7F8',
    '#EEF0F2',
    '#E5E8EB',
    '#DCE1E4',
    '#D3D9DE',
    '#BCC2C6',
    '#A3A8AB',
    '#85898C',
    '#5E6163',
  ] as MantineColorsTuple,
  blue: [
    '#e3f5ff',
    '#cde5ff',
    '#B8E3FA',
    '#66abfc',
    '#3a91fa',
    '#2887FA',
    '#0479fa',
    '#0067e0',
    '#005cca',
    '#004fb2',
  ] as MantineColorsTuple,
  red: [
    '#FBF3F3',
    '#F8E7E7',
    '#F2CECD',
    '#ECB0B0',
    '#E58D8C',
    '#DF5E5B',
    '#C75451',
    '#AC4846',
    '#8D3B39',
    '#632A28',
  ] as MantineColorsTuple,
  yellow: [
    '#FEFCF1',
    '#FEF9CC',
    '#FEF9CC',
    '#FBF198',
    '#FDE47E',
    '#F7D665',
    '#FED664', // Primary Yellow
    '#FFCE3E',
    '#FFC517',
    '#FFC517',
  ] as MantineColorsTuple,
  green: [
    '#f0faec',
    '#e3f0de',
    '#E2F2DB',
    '#C7DDBD',
    '#B7D0AC',
    '#8fbb7c',
    '#98B68B', // Primary Green
    '#7B9A75',
    '#5E7F5E',
    '#416348',
  ] as MantineColorsTuple,
  'bright-green': [
    '#e7fdee',
    '#d8f4e0',
    '#b3e6c3',
    '#8bd7a2',
    '#6acb87',
    '#5BC67B',
    '#47c06b',
    '#37a859',
    '#2c964e',
    '#1b8240',
  ] as MantineColorsTuple,
  dark: [
    '#F3F4F5',
    '#E6E8EB', // 1. Text 100
    '#CBD0D6',
    '#ACB4BE',
    '#8694A4',
    '#506A84',
    '#475E76', // 6. Text Secondary
    '#3D5266',
    '#324353',
    '#232F3B', // 9. Theme Black
  ] as MantineColorsTuple,
  tan: [
    '#FFFCF1',
    '#FEF7E9',
    '#FEF3DE',
    '#FFF0D1',
    '#F2D9A8',
    '#E9C06F',
    '#B4A582',
    '#A59164',
    '#907E53',
    '#817047',
  ] as MantineColorsTuple,
  orange: [
    '#FDF2ED',
    '#F9E7D2',
    '#EFCCA4',
    '#F0B48E',
    '#F4A07A',
    '#F88E61',
    '#FF7F49', // Primary Orange
    '#F5722B',
    '#EA640D',
    '#EA640D',
  ] as MantineColorsTuple,
  purple: [
    '#E5BFF7',
    '#E5BFF7',
    '#E5BFF7',
    '#BA97D9',
    '#8F6EBB',
    '#965FDD',
    '#9C4FFF', // Primary Purple
    '#7C42C7',
    '#5C358F',
    '#5C358F',
  ] as MantineColorsTuple,
}
